import { render, staticRenderFns } from "./peiXunManager.vue?vue&type=template&id=63052d6d"
import script from "./peiXunManager.vue?vue&type=script&lang=js"
export * from "./peiXunManager.vue?vue&type=script&lang=js"
import style0 from "./peiXunManager.vue?vue&type=style&index=0&id=63052d6d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports